import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb } from "antd";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { translateMenuName } from "../../utils/menuLabel";
import { Menu, MenuList } from "../../utils/constants";
import { useBreadcrumbLabels } from "./BreadcrumbContext";

const HOME_PATH = "/dashboard";

// URL segments that have no menu entry (nhãn nằm ở breadcrumb.segments.* trong locales)
const SEGMENT_KEYS = ["add", "create", "edit", "menus", "registration", "reorder", "settings"];

interface MenuInfo {
  name: string;
  isGroup: boolean;
}

const flattenMenu = (menus: Menu[], acc: Record<string, MenuInfo> = {}) => {
  menus.forEach((menu) => {
    const hasChildren = !!menu.routes && menu.routes.length > 0;
    acc[menu.path] = { name: menu.name, isGroup: hasChildren };
    if (hasChildren) flattenMenu(menu.routes as Menu[], acc);
  });
  return acc;
};

const MENU_INFO = flattenMenu(MenuList);

const isIdSegment = (segment: string) => /^\d+$/.test(segment) || /^[0-9a-f-]{16,}$/i.test(segment);

const AppBreadcrumb = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const labels = useBreadcrumbLabels();
  const segments = pathname.split("/").filter(Boolean);

  const items = [
    {
      key: HOME_PATH,
      title:
        segments.length === 0 || pathname === HOME_PATH ? (
          <HomeOutlined />
        ) : (
          <Link to={HOME_PATH}>
            <HomeOutlined />
          </Link>
        ),
    },
  ];

  segments.forEach((segment, index) => {
    const path = `/${segments.slice(0, index + 1).join("/")}`;
    if (path === HOME_PATH) return;

    const menu = MENU_INFO[path];
    const label =
      labels[path] ||
      (menu && translateMenuName(t, { path, name: menu.name })) ||
      (SEGMENT_KEYS.includes(segment) ? t(`breadcrumb.segments.${segment}`) : "") ||
      (isIdSegment(segment) ? `#${segment}` : segment);
    const isLast = index === segments.length - 1;
    // Only real pages are clickable: skip the current page, menu groups and unknown segments
    const linkable = !isLast && !!menu && !menu.isGroup;

    items.push({
      key: path,
      title: linkable ? (
        <Link to={path}>{label}</Link>
      ) : (
        <span style={isLast ? { fontWeight: 600, color: "#ba2156" } : undefined}>{label}</span>
      ),
    });
  });

  return <Breadcrumb items={items} style={{ padding: "16px 0 8px 24px", fontSize: 14 }} />;
};

export default AppBreadcrumb;
